import { useState, useEffect, useCallback } from 'react';
import { getReferees } from '@/api/TournamentManagement/refereeApi';
import type { RefereeListView, RefereeListQuery } from '@/models/tournament';

export function useReferees(query: RefereeListQuery) {
  const [data, setData] = useState<RefereeListView | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetch = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await getReferees(query);
      if (result.status < 400 && result.errors.length === 0) {
        setData(result.payload);
      } else {
        setError(result.errors[0]?.description || 'An error occurred');
      }
    } catch {
      setError('Network error');
    } finally {
      setLoading(false);
    }
  }, [query.search, query.certification, query.page, query.pageSize]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { data, loading, error, refetch: fetch };
}
